import { call, put, takeLatest } from 'redux-saga/effects';
import type { PayloadAction } from '@reduxjs/toolkit';
import request from '@/utils/request';
import API from '@/config/api';
import type { SurveyField } from '@/types/survey.types';
import {
  fetchSurveyFieldsRequest, fetchSurveyFieldsSuccess, fetchSurveyFieldsFailure,
  fetchQuizInfoRequest, fetchQuizInfoSuccess, fetchQuizInfoFailure,
  saveQuizWeightsRequest, saveQuizWeightsSuccess, saveQuizWeightsFailure,
  saveSurveyLogicRequest, saveSurveyLogicSuccess, saveSurveyLogicFailure,
} from './customizeTemplateSlice';

function* handleFetchSurveyFields(action: PayloadAction<string>) {
  try {
    const res: { data: { data: SurveyField[] } } = yield call(request.get, API.SURVEY_FIELDS(action.payload));
    yield put(fetchSurveyFieldsSuccess(res.data.data));
  } catch (e: unknown) {
    console.error('handleFetchSurveyFields error:', e);
    yield put(fetchSurveyFieldsFailure());
  }
}

function* handleFetchQuizInfo(action: PayloadAction<string>) {
  try {
    const res: { data: { data: Record<string, unknown> } } = yield call(request.get, API.QUIZ_INFO(action.payload));
    yield put(fetchQuizInfoSuccess(res.data.data));
  } catch (e: unknown) {
    console.error('handleFetchQuizInfo error:', e);
    yield put(fetchQuizInfoFailure());
  }
}

function* handleSaveQuizWeights(action: PayloadAction<{ surveyId: string; weights: Record<string, unknown> }>) {
  try {
    yield call(request.post, API.QUIZ_WEIGHTS(action.payload.surveyId), action.payload.weights);
    yield put(saveQuizWeightsSuccess());
  } catch (e: unknown) {
    console.error('handleSaveQuizWeights error:', e);
    yield put(saveQuizWeightsFailure(e instanceof Error ? e.message : 'Failed'));
  }
}

function* handleSaveSurveyLogic(action: PayloadAction<{ surveyId: string; logic: Record<string, unknown> }>) {
  try {
    yield call(request.post, API.SURVEY_LOGIC(action.payload.surveyId), action.payload.logic);
    yield put(saveSurveyLogicSuccess());
  } catch (e: unknown) {
    console.error('handleSaveSurveyLogic error:', e);
    yield put(saveSurveyLogicFailure(e instanceof Error ? e.message : 'Failed'));
  }
}

export default function* customizeTemplateSaga() {
  yield takeLatest(fetchSurveyFieldsRequest.type, handleFetchSurveyFields);
  yield takeLatest(fetchQuizInfoRequest.type, handleFetchQuizInfo);
  yield takeLatest(saveQuizWeightsRequest.type, handleSaveQuizWeights);
  yield takeLatest(saveSurveyLogicRequest.type, handleSaveSurveyLogic);
}
